"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_helmet_1 = require("react-helmet");
exports.LogoMicrodata = ({ logo, url, }) => {
    const finalJson = `{
    "@context": "https://schema.org",
    "@type": "Organization",
    "logo": "${logo}",
    "url": "${url}"
  }`;
    return (React.createElement(react_helmet_1.Helmet, null,
        React.createElement("script", { type: "application/ld+json" }, finalJson)));
};
